.changeSummary {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-lg);
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-gray-0);
}

.changeLabel {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--mantine-color-gray-6);
}

.changeFrom {
    text-decoration: line-through;
}

.timeline {
    border-top: 1px solid var(--mantine-color-gray-2);
}

.row {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding: 9px 2px;
    border-bottom: 1px solid var(--mantine-color-gray-1);
}

.dot {
    flex: none;
    width: 9px;
    height: 9px;
    border-radius: 50%;
}

/* Removed rows keep their place in the timeline but read as an outline, not a solid stop. */
.dotHollow {
    background-color: transparent !important;
    box-shadow: inset 0 0 0 1.5px var(--mantine-color-gray-4);
}

.rowDate {
    flex: 1;
    min-width: 0;
}

.runRow {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding: 7px 2px;
    border-bottom: 1px solid var(--mantine-color-gray-1);
}

.runRail {
    flex: none;
    width: 9px;
    text-align: center;
    line-height: 0.5;
    font-weight: 700;
    color: var(--mantine-color-gray-4);
}

.footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--mantine-spacing-sm);
    margin: 0 calc(-1 * var(--mantine-spacing-md)) calc(-1 * var(--mantine-spacing-md));
    padding: var(--mantine-spacing-md);
    border-top: 1px solid var(--mantine-color-gray-2);
    background-color: var(--mantine-color-gray-0);
}

/* Each status tag is its own definition: the question mark says "hover me". */
.helpBadge {
    cursor: help;
}

.helpBadge :global(.mantine-Badge-section) {
    display: flex;
    align-items: center;
    opacity: 0.65;
}
